import React from 'react';
import '../CSS/SocialLinks.css';

const SocialLinks = () => {
  const socialMedia = [
    {
      name: 'Facebook',
      icon: '📘',
      url: 'https://www.facebook.com/pacmusclecrete',
      label: 'Facebook'
    },
    {
      name: 'LinkedIn',
      icon: '💼',
      url: 'https://www.linkedin.com/company/pac-corporation',
      label: 'LinkedIn'
    },
    {
      name: 'Instagram',
      icon: '📷',
      url: 'https://www.instagram.com/musclecrete',
      label: 'Instagram'
    },
    {
      name: 'YouTube',
      icon: '📹',
      url: 'https://www.youtube.com/@musclecrete',
      label: 'YouTube'
    },
    {
      name: 'Twitter',
      icon: '𝕏',
      url: 'https://twitter.com/musclecrete',
      label: 'Twitter'
    }
  ];

  return (
    <div className="social-links">
      {socialMedia.map(social => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          title={social.label}
          aria-label={social.label}
        >
          <span className="social-icon">{social.icon}</span>
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
